// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2KWq0","title":"Info_title__2KDyY","links":"Info_links__3bv5w","link":"Info_link__27y87","logo":"Info_logo__3p9aP"};